import React, { Fragment } from 'react'
import { formatDbDateWithoutTime } from '../../utils/dateFormater';
import ReportButtons from './ReportButtons';

const SingleOrderReport = ({ order, user }) => {






    const displayIndex = String((order?.order_id)).padStart(6, '0');

    const handleClassName = (orderStatus) => {


        if (orderStatus === "RESOLVED") return "text-green-600 bg-green-100";
        if (orderStatus === "PENDING") return "text-orange-500 bg-orange-100";
        if (orderStatus === "UNDER_REVIEW") return "text-blue-500 bg-blue-100";
        if (orderStatus === "REJECTED" || orderStatus === "CANCELLED") return "text-red-500 bg-red-100";
        if (orderStatus === "URGENT") return "text-purple-500 bg-purple-100";

    }



    return (
        <Fragment>
            <div className={`flex w-[240%] lg:w-full py-[1.2vmax] mt-[1vmax] rounded-xl shadow-2 border-l-[0.2vmax] border-indigo-600 items-center bg-white`}>
                <div className="text-center flex-center items-center flex-[0.5] min-w-[70px] flex-shrink-0 text-[#4c4c5c] font-bold text-[1.5vmax] lg:text-[0.8vmax]" >
                    #{displayIndex}
                </div>
                <div className="px-[0.5vmax] flex-[1.5] min-w-[150px] flex-shrink-0 text-[#4c4c5c] font-bold text-[1.5vmax] lg:text-[0.8vmax] flex items-center" >
                    {order?.report_type.replaceAll("_", " ")}
                </div>

                <div className="flex flex-center flex-col px-[0.5vmax] flex-[2] min-w-[220px] flex-shrink-0 text-[#4c4c5c] text-[1.5vmax] lg:text-[0.8vmax]" >
                    <span className="font-bold text-gray-700 capitalize">
                        {order?.reported_by_name ? order?.reported_by_name : "N/A"}
                        <span className='text-[0.7vmax] text-gray-500 font-medium' >&nbsp;(
                            {order?.reported_by === user?.id ?
                                "You"
                                :
                                order?.reported_by_role
                            }
                            )</span>
                    </span>
                    {order?.reported_by_pmm_id ?
                        <span className='text-gray-500 text-[0.75vmax]' >ID: {String(order?.reported_by_pmm_id).padStart(2, '0')}</span>
                        :
                        <span className='text-gray-500 text-[0.75vmax]' >ID: {order?.reported_by}</span>
                    }
                </div>

                <div className="flex-center flex-col text-center px-[0.5vmax] flex-[2] min-w-[220px] flex-shrink-0 text-[#4c4c5c] text-[1.5vmax] lg:text-[0.8vmax]" >
                    <span className="font-bold text-gray-700 capitalize">
                        {order?.against_user_name ? order?.against_user_name : "N/A"}
                        {order?.against_user_id === user?.id ?
                            <span className='text-[0.7vmax] text-gray-500 font-medium' >&nbsp;(You)</span>
                            :
                            <span className='text-[0.7vmax] text-gray-500 font-medium' >&nbsp;({order?.against_user_role})</span>
                        }
                    </span>
                    {order?.against_user_pmm_id ?
                        <span className='text-gray-500 text-[0.75vmax]' >ID: {String(order?.against_user_pmm_id).padStart(2, '0')}</span>
                        :
                        <span className='text-gray-500 text-[0.75vmax]' >ID: {order?.against_user_id}</span>
                    }
                </div>

                <div className="text-center flex-center px-[0.5vmax] flex-[1.5] min-w-[150px] flex-shrink-0 text-[#4c4c5c] text-[1.5vmax] lg:text-[0.8vmax]" >
                    <span className="font-bold text-gray-700 capitalize">
                        {order?.resolved_by_name ? order?.resolved_by_name : "N/A"}
                        {
                            order?.resolved_by === user?.id ?
                                <span className='text-[0.7vmax] text-gray-500 font-medium' >&nbsp;(You)</span>
                                :
                                <span className='text-[0.7vmax] text-gray-500 font-medium' >&nbsp;({order?.resolved_by_role})</span>
                        }
                    </span>
                </div>
                
                <div className="text-center flex-center px-[0.5vmax] flex-[1] min-w-[120px] flex-shrink-0 text-gray-500 font-medium text-[1.5vmax] lg:text-[0.8vmax]" >
                    {formatDbDateWithoutTime(order?.created_at)}
                </div>

                <div className="flex-center px-[0.5vmax] flex-[1] min-w-[120px] flex-shrink-0 " >
                    <span className={`text-[1.3vmax] lg:text-[0.75vmax] font-bold uppercase p-[0.3vmax_0.8vmax] rounded-lg shadow-sm ${handleClassName(order?.status)}`} >
                        {order?.status.replaceAll("_", " ")}
                    </span>
                </div>

                {/* Action Column */}
                <div className="flex-center px-[0.5vmax] flex-[1.5] min-w-[160px] flex-shrink-0" >
                    <ReportButtons order={order} user={user} />
                </div>
            </div>
        </Fragment >
    )
}

export default SingleOrderReport